// @flow
import React, { Component } from "react";
import { browserHistory } from "react-router";
import QRCode from "qrcode.react";

import getMobileOperatingSystem from "../../global/functions/getMobileOs";
import { buttonStyles } from "../../global/components/StyledButtons";
import { ColorSchema } from "../../global/types/scss";

import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";

type CompleteInstructionPropsType = {
  classes: { [key: string]: string },
  setLoadError: Function,
  conferenceName: string,
  accessToken: string
};

class CompleteInstruction extends Component<CompleteInstructionPropsType, *> {
  constructor(props: CompleteInstructionPropsType) {
    super(props);
  }

  goStore = (): * => {
    if(getMobileOperatingSystem() === "Android"){
      window.location.href = "market://details?id=au.com.imagus.ImagusSpark";
    }
    else if (getMobileOperatingSystem() === "iOS") {
      window.location.href = "itms-apps://itunes.apple.com/au/app/imagus-spark/id1394918351?mt=8";
    }
    else {
      this.props.setLoadError("Can not detect your mobile OS.");
    }
  }

  goMobilePage = (): * => {
    let alterDomain = "";
    if(window.location.hostname === "conferences.imagus.com.au"){
      alterDomain = "http://conferences.imagus.com.au.s3-website-ap-southeast-2.amazonaws.com";
    }
    else if (window.location.hostname === "testconferences.imagus.com.au"){
      alterDomain = "http://testconferences.imagus.com.au.s3-website-ap-southeast-2.amazonaws.com";
    }

    window.location.href = alterDomain + "/" + this.props.conferenceName + "/mobileaccess/" + this.props.accessToken;
  }

  render(): React$Element<*> {
    const classes = this.props.classes;

    if (getMobileOperatingSystem() === "Android" || getMobileOperatingSystem() === "iOS") {
      return (
        <div className="fixed-bottom">
          <div className="flag-content">
            <i>Haven't installed our Spark app?<br />Click on the link below to download the Spark app on your phone.</i>
          </div>
          <Button color="primary" variant="raised" type='button' className={classes.primaryBtn + " top-margin-15 bottom-margin-15"} style={{ width: "auto" }} onClick={this.goStore}>Download Imagus Spark App</Button>
          <div className="flag-content">
            <i>Already downloaded Spark app?<br />Click on the link below to to login to your conference account in the app.</i>
          </div>
          <Button color="primary" variant="raised" type='button' className={classes.primaryBtn + " top-margin-15"} style={{ width: "auto" }} onClick={this.goMobilePage}>Launch Mobile App</Button>
        </div>
      );
    }
    else {
      return (
        <div className="fixed-bottom">
          <div className="flag-content">
            <i>Haven't installed our Spark app?<br />Scan the QR code below to download the Spark app on you phone.</i>
          </div>
          <div style={{ marginTop: "2%" }}>
            <QRCode
              value={window.location.origin + "/" + this.props.conferenceName + "/mobileaccess/" + this.props.accessToken}
              size={256}
              fgColor={ColorSchema("primary")}
            />
          </div>
          <div className="flag-content">
            <i>Already downloaded Spark app?<br />Scan the same QR code above to login to your conference account in the app.</i>
          </div>
        </div>
      );
    }
  };
}

export default withStyles(buttonStyles)(CompleteInstruction);



// WEBPACK FOOTER //
// ./src/conference/component/CompleteInstruction.js